import { MapMarkerDownIcon } from './MapMarkerDownIcon';

/**
 * author: François Risoud
 * id 6E4368BF-7150-40D2-861B-375421A7774B
 * name map-marker-down
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-down.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationDownIcon = MapMarkerDownIcon;
export default LocationDownIcon